import { render, staticRenderFns } from "./SnackBarGlobal.vue?vue&type=template&id=3a85a675&"
import script from "./SnackBarGlobal.vue?vue&type=script&lang=js&"
export * from "./SnackBarGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports